module.exports = __webpack_public_path__ + "img/fangan4.91fc5201.png";